import React from 'react';
import { sanitizeProductDescriptionHtml } from '../productDescriptionFormat';
import './ProductDescription.css';

export default function ProductDescription({ text }) {
    return (
        <div
            className='productDescriptionRich'
            dangerouslySetInnerHTML={{ __html: sanitizeProductDescriptionHtml(text) }}
        />
    );
}
